import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home.vue'
import User from '@/components/User.vue'
import Step from '@/components/Step.vue'

Vue.use(Router)

export default new Router({
  scrollBehavior: () => ({
    y: 80
  }),
  routes: [{
      path: '/login',
      name: 'login',
      meta: {
        title: '登录',
        title_zh: '登录',
        title_en: 'Login'
      },
      component: () =>
        import('@/views/Login')
    },
    { // 注册
      path: '/step',
      name: 'step',
      component: Step,
      children: [{
          path: 'stepuserinfo',
          name: 'stepuserInfo',
          meta: {
            title: '个人资料'
          },
          component: () =>
            import('@/views/step/StepUserInfo')
        },
        {
          path: 'stepquestion',
          name: 'stepquestion',
          meta: {
            title: '问卷'
          },
          component: () =>
            import('@/views/step/StepQuestion')
        },
        {
          path: 'stepinvite',
          name: 'stepinvite',
          meta: {
            title: '同事'
          },
          component: () =>
            import('@/views/step/StepInvite')
        },
        {
          path: 'stepinvitecolleagues',
          name: 'stepinvitecolleagues',
          meta: {
            title: '邀请同事'
          },
          component: () =>
            import('@/views/step/StepInviteColleagues')
        },
        {
          path: 'stepconfirmation',
          name: 'stepconfirmation',
          meta: {
            title: '确认涵'
          },
          component: () =>
            import('@/views/step/StepConfirmation')
        }
      ]
    },
    { //个人中心
      path: '/user',
      name: 'user',
      component: User,
      children: [{
          path: 'userInfo',
          name: 'userInfo',
          meta: {
            title: '个人资料'
          },
          component: () =>
            import('@/views/user/UserInfo')
        },
        {
          path: 'vip',
          name: 'vip',
          meta: {
            title: 'vip申请'
          },
          component: () =>
            import('@/views/user/vip')
        },
        {
          path: 'questionnaire',
          name: 'questionnaire',
          meta: {
            title: '问卷调查'
          },
          component: () =>
            import('@/views/user/Questionnaire')
        },
        {
          path: 'confirmation',
          name: 'confirmation',
          meta: {
            title: '我的确认函'
          },
          component: () =>
            import('@/views/user/Confirmation')
        },
        {
          path: 'invitefriends',
          name: 'invitefriends',
          meta: {
            title: '邀请好友'
          },
          component: () =>
            import('@/views/user/InviteFriends')
        },
        {
            path: 'inviteresult',
            name: 'inviteresult',
            meta: {
                title: '邀请结果'
            },
            component: () =>
                import ('@/views/user/InviteResult')
        }
      ]
    },
    {
        path: '/userConfirmation/:u',
        name: 'userConfirmation',
        meta: {
            title: '确认函'
        },
        component: () =>
            import ('@/views/userConfirmation')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js